import React from 'react'
import tw from 'tailwind-styled-components'
import {closePopup} from '../tooltip/content-on-hover'
import {OptionsItem} from './types'

interface DropdownMenuItemProps<T> {
  item: OptionsItem<T>
  withIcons?: boolean
  withNumbers?: boolean
  size?: '28' | '32' | '36' | '40'
  textSize?: '12' | '14'
  textColor?: string
  onChange?: (value: OptionsItem<T>) => void
}

const TwItemContainer = tw.div<{
  $marginBottom?: string
  $selected?: boolean
  $size: '28' | '32' | '36' | '40'
}>`
  group
  flex
  flex-row
  items-center
  gap-4

  px-12
  py-2
  select-none

  ${p => {
    if (p.$size === '28') {
      return 'h-28'
    }
    if (p.$size === '32') {
      return 'h-32'
    }
    if (p.$size === '36') {
      return 'h-36'
    }
    if (p.$size === '40') {
      return 'h-40'
    }
    return 'h-32'
  }}

  ${p => {
    return p.$selected
      ? 'pointer-events-none bg-interactive-l80'
      : 'hover:bg-interactive-l100 active:bg-interactive-l80'
  }}
  ${p => p.$marginBottom || ''}
`

const TwItemText = tw.div<{$textSize: '12' | '14'; $textColor?: string}>`
  whitespace-nowrap
  w-full

  text-ellipsis
  overflow-hidden

  ${p => (p.$textColor ? p.$textColor : 'text-primary')}

  ${p => {
    // это для левого меню, сейчас нет окончательного решения
    if (p.$textSize === '12') {
      return 'font-normal text-12 leading-4'
    }

    if (p.$textSize === '14') {
      return 'plain-text-regular'
    }

    return 'plain-text-regular'
  }}
`

const TwItemNumber = tw.div<{$highlightNumber?: boolean}>`
  ml-auto
  text-11
  leading-4
  whitespace-nowrap

  ${p => (p.$highlightNumber ? 'text-error-l20' : 'text-placeholder')}
`
const TwIcon16 = tw.div`
  w-16
  h-16
  min-h-16
  min-w-16
  max-h-16
  max-w-16
`

export const DropdownMenuItem = <T,>(props: DropdownMenuItemProps<T>) => {
  const {item, withIcons, withNumbers, size = '28', textSize = '14'} = props
  const {textColor, onChange} = props

  const cb = () => {
    onChange?.(item)
    item.cb?.()
    closePopup()
  }

  return (
    <TwItemContainer
      $selected={item.selected}
      onClick={cb}
      $marginBottom={item.marginBottom}
      $size={size}
    >
      {withIcons && <TwIcon16>{item.icon}</TwIcon16>}
      <TwItemText $textSize={textSize} $textColor={textColor}>
        {item.text}
      </TwItemText>
      {withNumbers && (
        <TwItemNumber $highlightNumber={item.highlightNumber}>
          {item.count}
        </TwItemNumber>
      )}
    </TwItemContainer>
  )
}
